module.exports = __webpack_public_path__ + "img/numCard-8_SC.4abc210a.svg";